import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { motion, MotionConfig } from 'framer-motion';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import DraftingGrid from '@/components/DraftingGrid';
import ScrollToHash from '@/components/ScrollToHash';
import Home from '@/pages/Home';
import NotFound from '@/pages/NotFound';
import { ThemeProvider } from '@/context/ThemeContext';

const App = (): JSX.Element => {
  return (
    <ThemeProvider>
      <MotionConfig reducedMotion="user">
        <Router>
          <ScrollToHash />
          <div className="relative min-h-screen bg-paper-50 text-[color:var(--fg)] transition-colors duration-300 dark:bg-ink-800">
            <DraftingGrid />
            <Navbar />
            {/* Animate opacity ONLY. A transform/filter/perspective here would create a
                containing block and break `position: fixed` for ContactJumpCue inside. */}
            <motion.main
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5 }}
              className="relative z-10 mx-auto w-full max-w-6xl px-5 pb-8 pt-24 sm:px-8"
            >
              <Routes>
                <Route path="/" element={<Home />} />
                {/* Contact now lives on the home page; keep the old URL as a jump shortcut. */}
                <Route path="/contact" element={<Navigate to="/#contact" replace />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </motion.main>
            <Footer />
          </div>
        </Router>
      </MotionConfig>
    </ThemeProvider>
  );
};

export default App;
